<template>
  <b-card>
    <FormBuilder
      label="Product"
      create
      :fields="fields"
      :loading-submit="$store.state.product.loadingSubmit"
      @submit="submitData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/product'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    submitData(data, callback) {
      this.$store.dispatch('product/create', data)
        .then(callback)
    },
  },
}
</script>

<style scoped>

</style>
